import React from "react";
import { Box } from "@mui/material";
import { sanitizeAnnouncementHtml } from "../../../api_calls/announcementUtils";

export const announcementRichTextSx = {
  lineHeight: 1.35,
  "& p, & div, & h1, & h2, & h3, & blockquote, & ul, & ol, & li": {
    margin: 0,
    paddingTop: 0,
    paddingBottom: 0,
    lineHeight: 1.35,
  },
  "& ul, & ol": {
    paddingLeft: "1.25rem",
  },
  "& h1": {
    fontSize: "1.25em",
    fontWeight: 700,
  },
  "& h2": {
    fontSize: "1.15em",
    fontWeight: 700,
  },
  "& h3": {
    fontSize: "1em",
    fontWeight: 700,
  },
  "& blockquote": {
    paddingLeft: "0.75rem",
    borderLeft: "3px solid #d0d0d6",
  },
  "& a": {
    color: "#AF3241",
    textDecoration: "underline",
  },
};

const AnnouncementHtml = ({ html, clampLines }) => (
  <Box
    onClick={(event) => {
      if (event.target.closest && event.target.closest("a")) {
        event.stopPropagation();
      }
    }}
    sx={{
      color: "#1E1E28",
      fontSize: "0.875rem",
      ...announcementRichTextSx,
      ...(clampLines
        ? {
            maxHeight: `${1.35 * clampLines}em`,
            overflow: "hidden",
          }
        : {}),
    }}
    dangerouslySetInnerHTML={{ __html: sanitizeAnnouncementHtml(html) }}
  />
);

export default AnnouncementHtml;
